import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locales/en.json'
import fr from '@/locales/fr.json'
import es from '@/locales/es.json'

Vue.use(VueI18n)

function getDeviceLocale() {
  const lang = navigator.language || navigator.userLanguage || 'en'
  const prefix = lang.split('-')[0].toLowerCase()
  if (['fr', 'es'].includes(prefix)) {
    return prefix
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getDeviceLocale(),
  fallbackLocale: 'en',
  messages: { en, fr, es },
})

export default i18n
